import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { ButtonToolbar, ButtonGroup, Button } from 'react-bootstrap';
import { processDataCollection } from '../actions/application.js';
import _ from 'lodash';

class DataCollectionsAnalysisToolContainer extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(datacollection) {
        this.props.processDataCollection(datacollection);
    }

    getToolDescription(tool, properties){
        var description = "[" + tool + "]";
        for (var i =0; i < properties.length; i++){ 
            description = description + "_" + properties[i].dataCollectionNumber + "_" + properties[i].imagePrefix + "_(_" + properties[i].numberOfImages + "_images),";
        }
        return description;
    }
    render() {
        
        var _this = this;
        var ids = _.map(this.props.datacollections, "dataCollectionId");

        if (this.props.configuration.dataAnalysis.enabled) {            
            if (this.props.jobs.datacollectionJobTypes) {
                let properties = _.map(this.props.datacollections, function(e){ return { "imagePrefix" : e.imagePrefix,  "dataCollectionNumber" : e.dataCollectionNumber,  "numberOfImages" : e.numberOfImages}});
                return <ButtonToolbar>
                    {Object.keys(this.props.jobs.datacollectionsJobTypes).map(function (key) {
                        return (
                            <ButtonGroup>
                                <Link disabled target="_blank" to={"/analysis/" + key + "?datacollectionids=" + ids + "&description=" + _this.getToolDescription("Merge", properties) }>
                                    <Button onClick={()=>_this.handleClick(_this.props.datacollection)} bsStyle="primary">{key}</Button>
                                </Link>
                            </ButtonGroup>);
                    })}
                </ButtonToolbar>
            }
        }
        return null;
    }
}


function mapStateToProps(state) {
    return {
        jobs: state.jobs,
        configuration: state.configuration
    };
}

function mapDispatchToProps(dispatch) {
    return {         
        processDataCollection : (dataCollection) => dispatch(processDataCollection(dataCollection)),                            
      };
}



export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DataCollectionsAnalysisToolContainer);



// WEBPACK FOOTER //
// ./src/containers/DataCollectionsAnalysisToolContainer.js